import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PanelState {
  isVisible: boolean;
  node_instance_id: string | null;
  height: number;
}

const initialState: PanelState = {
  isVisible: false,
  node_instance_id: null,
  height: 600,
};

const panelSlice = createSlice({
  name: 'panel',
  initialState,
  reducers: {
    setVisibility(state, action: PayloadAction<boolean>) {
      state.isVisible = action.payload;
    },
    toggleVisibility(state) {
      state.isVisible = !state.isVisible;
    },
    setNodeInstanceId(state, action: PayloadAction<string | null>) {
      state.node_instance_id = action.payload;
    },
    setHeight(state, action: PayloadAction<number>) {
      state.height = action.payload;
    },
    clearPanel(state) {
      state.isVisible = false;
      state.node_instance_id = null;
    },
  },
});

export const { setVisibility, toggleVisibility, setNodeInstanceId, setHeight, clearPanel } = panelSlice.actions;

export default panelSlice.reducer;
